import { useParams } from "react-router-dom";
import { Nullable, Product } from "utils/types/util.types";
import { Helmet } from "react-helmet";
import SingleProductPageBasicInformation from "components/SingleProductPage/SingleProductPageBasicInformation";
import SingleProductPageHighlights from "components/SingleProductPage/SingleProductPageHighlights";
import SingleProductPageUsage from "components/SingleProductPage/SingleProductPageUsage";
import SubpageHero from "components/utils/SubpageHero";
import { products } from "utils/constants/constants";
import SingleProductPageTable from "components/SingleProductPage/SingleProductPageTable";
import { useTranslation } from "react-i18next";
import React from "react";
import SingleProductPageBottomText from "components/SingleProductPage/SingleProductPageBottomText";
import SingleProductPageGallery from "components/SingleProductPage/SingleProductPageGallery";
import SingleProductPageBanner from "components/SingleProductPage/SingleProductPageBanner";

function SingleProductPage() {
	const { t } = useTranslation();

	const { productId = "0" } = useParams();

	const product: Nullable<Product> = products.find(product => product.id === Number(productId));

	if (!product) return (
		<SubpageHero
			title="Brak produktu"
			description="Przejdź na stronę produktów zobaczyć wszystkie produkty"
		/>);

	const {
		textId,
		basicInformationImage,
		gallery,
		banner
	} = product;

	return (
		<>
			<Helmet title={ `${ t(`products.${ textId }.title`) } | Lark-stretch` }/>
			<SubpageHero
				title={ t(`products.${ textId }.title`) }
				description={ t(`products.${ textId }.description`) }
			/>
			<SingleProductPageBasicInformation productTextId={ textId } image={ basicInformationImage }/>
			<SingleProductPageHighlights productTextId={ textId }/>
			<SingleProductPageUsage productTextId={ textId }/>
			<SingleProductPageBanner productTextId={ textId } image={ banner }/>
			<SingleProductPageGallery productTextId={ textId } images={ gallery }/>
			<SingleProductPageTable productTextId={ textId }/>
			<SingleProductPageBottomText productTextId={ textId }/>
		</>
	);
}

export default SingleProductPage;